<template lang="pug">
md-layout(md-column)
  // Page loader
  loader(v-if='loadingComponent', :loading='loadingComponent', :size='45')
  // Page content
  md-theme(md-name='blue', v-else)
    // Title
    breadcrumbs#scrollToError(section='Licenses', :nav='nav')

    // Form
    md-layout.form-wrapper(:md-gutter='16')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          metadata-form(title='License', :entity='license', :form-submitted='formSubmitted', :validations='$v.license')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          .md-headline#geo-title Geographic Rules
          .md-subheading Approach
          md-radio.md-primary(v-model='license.geoList.mode', md-value='allow') Allow
          md-radio.md-primary(v-model='license.geoList.mode', md-value='deny') Deny
          country-selector(v-model='license.geoList.countries')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          domains-form(:entity='license', @created='showAlertToast($event, "success")', @error='showAlertToast($event, "error")')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          platforms-form(:entity='license')
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          .md-headline#window-title Licensing Window
          status-radio(v-model='license.status')
          date-input(v-show="license.status !== 'draft' ? true : false", v-model='license.startDate', :validation='$v.license.startDate', :formSubmitted='formSubmitted', label="Available from")
          date-input(v-show="license.status !== 'draft' ? true : false", v-model='license.endDate',  :validation='$v.license.endDate', :formSubmitted='formSubmitted', label="Available until")
      md-layout(md-flex='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          pricing-form(:entity='license')
      md-layout(md-align='center')
        stitch-loader(:loading='creatingOrUpdating', :size='40')
        md-button#submit-btn.md-raised.md-primary(@click='onFormSubmit', v-show='!creatingOrUpdating', :disabled="$v.$pending", md-theme='blue')
          | {{ editMode ? 'Update' : 'Create' }}
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { isValidDate } from "../../services/validatorService";
import licenseService from "../../services/licenseService";
import StitchLoader from "../../shared-components/Loader";
import DateInput from "../../shared-components/forms/DateInput";
import MetadataForm from "../../shared-components/forms/MetadataForm";
import DomainsForm from "../../shared-components/forms/DomainsForm";
import PlatformsForm from "../../shared-components/forms/PlatformsForm";
import PricingForm from "../../shared-components/forms/PricingForm";
import CountrySelector from "../../shared-components/country/CountrySelector";
import StatusRadio from "../../shared-components/StatusRadio";
import Breadcrumbs from "../../shared-components/Breadcrumbs";
import Loader from "../../shared-components/Loader";

export default {
  mixins: [validationMixin],
  components: {
    MetadataForm,
    DomainsForm,
    PlatformsForm,
    PricingForm,
    StitchLoader,
    CountrySelector,
    DateInput,
    StatusRadio,
    Breadcrumbs,
    Loader,
  },
  computed: {
    nav() {
      return [
        { title: "Licenses", route: "LicenseList" },
        { title: this.editMode ? "Edit License" : "New License" },
      ];
    },
    editMode() {
      return !!this.$route.params.id;
    },
  },
  data() {
    return {
      formSubmitted: false,
      license: {
        name: "",
        description: "",
        shortDescription: "",
        tags: [],
        status: "draft",
        startDate: "",
        endDate: "",
        outletList: {
          mode: "whitelist",
          domainLists: [],
        },
        geoList: {
          mode: "deny",
          countries: [],
        },
        platforms: {
          mobile_web: true,
          mobile_app: true,
          tablet: true,
          desktop: true,
          ott: true,
          connectedtv: true,
        },
        pricing: [{ unit: "cpm", countries: [], price: 0 }],
      },
      loadingComponent: true,
      creatingOrUpdating: false,
      licenseOriginalName: null
    };
  },
  validations: {
    license: {
      name: {
        required,
        async isUnique(value) {
          const hasToCheck =
            !this.editMode || value !== this.licenseOriginalName;
          if (value && hasToCheck) {
            const response = await licenseService.getList({
              exactName: value,
              limit: 1,
            });
            return response.data.total === 0;
          } else {
            return true;
          }
        },
      },
      shortDescription: {
        default:true,
      },
      description: {
        default:true,
      },
      startDate: {
          validDate(value) {
            if (this.license.status === 'public') {
              return value ? isValidDate(value) : false;
            } else {
              return true;
            }
          }
        },
        endDate: {
          validDate(value) {
            if (this.license.status === 'public') {
              return value ? isValidDate(value) : false;
            } else {
              return true;
            }
          }
        }
    },
  },
  methods: {
    showAlertToast(text, icon){
        this.$swal({
              text: text,
              position: 'bottom-left',
              icon: icon,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
              }
            )
      },

  async createLicense() {
    await this.handleLicense(() => licenseService.create(this.license));
  },
  async updateLicense() {
    await this.handleLicense(() => licenseService.update(this.$route.params.id, this.license));
  },

  async handleLicense(action) {
  try {
    this.creatingOrUpdating = true;
    await action();
    const successMessage = this.editMode ? 'License updated successfully' : 'License created successfully';
    this.showAlertToast(successMessage, 'success');
    this.$delayedNavigation(this.$router, 'LicenseList');
  } catch (error) {
    const errorMessage = this.editMode ? 'License could not be updated. Please, try again later' : 'License could not be created. Please, try again later';
    this.showAlertToast(errorMessage, 'error');
  } finally {
    this.creatingOrUpdating = false;
  }
},
    onFormSubmit() {
      this.formSubmitted = true;
      if (!this.$v.$invalid ) {
        if (this.editMode) {
          this.updateLicense();
        } else {
          this.createLicense();
        }
      }else{
        const scrollToError = this.$el.querySelector("#scrollToError");
        scrollToError.scrollIntoView({ behavior: "smooth" })
      }
    },
  },
  async mounted() {
    if (this.editMode) {
    try {
      const response = await licenseService.get(this.$route.params.id);
      this.license = response.data.license;
      this.licenseOriginalName = this.license.name;
      if (this.license.startDate) {
        this.license.startDate = this.license.startDate.substr(0, 10);
      }
      if (this.license.endDate) {
        this.license.endDate = this.license.endDate.substr(0, 10);
      }
    } catch (error) {
      this.showAlertToast('License data could not be retrieved. Please, try again later', 'error');
    }
  }
  this.loadingComponent = false;
}
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  width: 100%;
  padding: 25px 10%;
  @media (max-width: 1200px) {
    padding: 10px 0.5%;
    margin-left: 0;
  }
  .md-layout {
    margin-bottom: 5px;
  }
}
.form-wrapper-frame {
  width: 100%;
  padding: 25px;
  margin-bottom: 15px;
}
.title-icon {
  margin-top: -5px;
}
.switch-label {
  margin-top: -4px;
  .md-icon {
    margin-right: 5px;
  }
}
.md-select-value {
  white-space: normal;
}
#submit-btn {
  margin: 25px 0;
  width: 33%;
  padding: 6px;
  font-size: 1.1em;
}
#window-title,
#geo-title {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/spa/license/LicenseForm.vue